import { createGlobalStyle } from 'styled-components';

export const ToasterStyles = createGlobalStyle`
    .Toastify__toast-body{
        align-items: flex-start;
    }

    .Toastify__toast-theme--colored.Toastify__toast--info {
        border: 1px solid;
        border-color: ${(props) => props.theme.palette.toastColors.blue.border};
        font-size: 13px;
        color: ${(props) => props.theme.palette.toastColors.blue.text};
        background-color: ${(props) =>
            props.theme.palette.toastColors.blue.background};
        padding: 8px;
    }
    .Toastify__progress-bar-theme--colored.Toastify__progress-bar--info {
        background-color: ${(props) =>
            props.theme.palette.toastColors.blue.progressBar};
    }

    .Toastify__toast-theme--colored.Toastify__toast--success {
        border: 1px solid;
        border-color: ${(props) =>
            props.theme.palette.toastColors.green.border};
        font-size: 13px;
        color: ${(props) => props.theme.palette.toastColors.green.text};
        background-color: ${(props) =>
            props.theme.palette.toastColors.green.background};
        padding: 8px;
    }
    .Toastify__progress-bar-theme--colored.Toastify__progress-bar--success {
        background-color: ${(props) =>
            props.theme.palette.toastColors.green.progressBar};
    }

    .Toastify__toast-theme--colored.Toastify__toast--warning {
        border: 1px solid;
        border-color: ${(props) =>
            props.theme.palette.toastColors.yellow.border};
        font-size: 13px;
        color: ${(props) => props.theme.palette.toastColors.yellow.text};
        background-color: ${(props) =>
            props.theme.palette.toastColors.yellow.background};
        padding: 8px;
    }
    .Toastify__progress-bar-theme--colored.Toastify__progress-bar--warning {
        background-color: ${(props) =>
            props.theme.palette.toastColors.yellow.progressBar};
    }

    .Toastify__toast-theme--colored.Toastify__toast--error {
        border: 1px solid;
        border-color: ${(props) => props.theme.palette.toastColors.red.border};
        font-size: 13px;
        color: ${(props) => props.theme.palette.toastColors.red.text};
        background-color: ${(props) =>
            props.theme.palette.toastColors.red.background};
        padding: 8px;
    }
    .Toastify__progress-bar-theme--colored.Toastify__progress-bar--error {
        background-color: ${(props) =>
            props.theme.palette.toastColors.red.progressBar};
    }
`;
